import {
  GET_WORK_FLOW,
  GET_WORK_FLOW_CLEAR_DATA,
  GET_WORK_FLOW_ERROR,
  GET_WORK_FLOW_SUCCESS,
  START_WORK_FLOW,
  START_WORK_FLOW_CLEAR_DATA,
  START_WORK_FLOW_ERROR,
  START_WORK_FLOW_SUCCESS,
} from "./actionTypes";

const initialState = {
  loadingWorkFlow: false,
  responseWorkFlow: null,
  errorWorkflow: null,

  loadingStartWorkFlow: false,
  responseStartWorkFlow: null,
  errorStartWorkflow: null,
};

const WorkFlow = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORK_FLOW:
      state = {
        ...state,
        loadingWorkFlow: true,
        responseWorkFlow: null,
        errorWorkflow: null,
      };
      break;
    case GET_WORK_FLOW_SUCCESS:
      state = {
        ...state,
        loadingWorkFlow: false,
        responseWorkFlow: action.payload,
        errorWorkflow: null,
      };
      break;
    case GET_WORK_FLOW_ERROR:
      state = {
        ...state,
        loadingWorkFlow: false,
        responseWorkFlow: null,
        errorWorkflow: action.payload,
      };
      break;
    case GET_WORK_FLOW_CLEAR_DATA:
      state = {
        ...state,
        loadingWorkFlow: null,
        responseWorkFlow: false,
        errorWorkflow: null,
      };
      break;
    ///
    case START_WORK_FLOW:
      state = {
        ...state,
        loadingStartWorkFlow: true,
        responseStartWorkFlow: null,
        errorStartWorkflow: null,
      };
      break;
    case START_WORK_FLOW_SUCCESS:
      state = {
        ...state,
        loadingStartWorkFlow: false,
        responseStartWorkFlow: action.payload,
        errorStartWorkflow: null,
      };
      break;
    case START_WORK_FLOW_ERROR:
      state = {
        ...state,
        loadingStartWorkFlow: false,
        responseStartWorkFlow: null,
        errorStartWorkflow: action.payload,
      };
      break;
    case START_WORK_FLOW_CLEAR_DATA:
      state = {
        ...state,
        loadingStartWorkFlow: null,
        responseStartWorkFlow: false,
        errorStartWorkflow: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default WorkFlow;
